export default Object.freeze({
  listContainer: 'ul',
  link: '.ws-link',
  icon: 'ws-icon',
});
